import * as Yup from "yup";
import createLocalizationsSchema from "../Localizations/createLocalizationsSchema";

const GenderSchema = (localeCodes, isEdit = false) => Yup.object().shape({
  code: Yup
    .string()
    .label("Code")
    .required()
    .max(50),
  localizations: createLocalizationsSchema(localeCodes),
  icon: Yup.mixed().label("Icon").when([], {
    is: () => isEdit,
    then: (schema) => schema.nullable(),
    otherwise: (schema) => schema.required(),
  }),
});

export default GenderSchema;
